import { QuoteItemCoverageSearchRequestParams, QuoteItemCoveragesSearchResponse } from '@lio/api-types';
import { quoteItemQueryKey } from '@services/quoteItem/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useSearchQuoteItemCoverages = (params: QuoteItemCoverageSearchRequestParams) => {
  const client = useClient();
  const { quoteId } = params;
  const result = useQuery({
    queryKey: quoteItemQueryKey.searchQuoteItemCoverages(params),
    queryFn: () => client(`quote/${quoteId}/quote-item-coverage`).json<QuoteItemCoveragesSearchResponse>(),
    enabled: !!quoteId,
    staleTime: 20000,
  });
  return result;
};
